// src/App.js
import { useEffect, useState } from 'react';
import './App.css';
import {messaging, getToken, onMessage} from './firebase';

function App() {
  const [token, setToken] = useState('');

  useEffect(() => {
    async function requestPermissionAndToken() {
      try {
        const permission = await Notification.requestPermission();

        if (permission !== 'granted') {
          console.log('Разрешение на уведомления не получено');
          return;
        }

        const currentToken = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        });

        if (currentToken) {
          setToken(currentToken);
          console.log('FCM token:', currentToken);

          // Отправьте токен на ваш backend
          await fetch('https://your-backend.example.com/api/push-tokens', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: currentToken }),
          });
        } else {
          console.log('Не удалось получить токен');
        }
      } catch (error) {
        console.error('Ошибка получения FCM token:', error);
      }
    }

    requestPermissionAndToken();

    const unsubscribe = onMessage(messaging, (payload) => {
      const notificationTitle = 'Background Message Title';
      const notificationOptions = {
        body: 'Background Message body.',
        icon: '/logo192.png'
      };

      if (Notification.permission === 'granted') {
        new Notification(notificationTitle, notificationOptions);
      }
    });

    return () => unsubscribe();
  }, []);


  return (
    <div className="App">
      <header className="App-header">
        <h1>FCM подключен</h1>
        <p>Токен устройства:</p>
        <code style={{ wordBreak: 'break-all' }}>{token || 'token не получен'}</code>
      </header>
    </div>
  );
}

export default App;
